<template>
  <div class="pb__container">
    <div
      class="pb__progress"
      :style="{ width: animatedPercent + '%'}"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, default: 0 }
  },

  data: () => ({
    animatedPercent: 0
  }),
    
  mounted() {
    setTimeout(() => {
      this.animatedPercent = this.value
    }, 100)
  },
  
  watch: {
    percent(newVal) {
      this.animatedPercent = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
  .pb {
    &__container {
      width: 100%;
      height: 8px;
      border-radius: 8px;
      background: #D9D9D9;
      overflow: hidden;
    }

    &__progress {
      height: 8px;
      background: linear-gradient(158deg, #FCB045 4.86%, #FD1D1D 52.82%, #7700C7 100.77%);
      border-radius: 8px;
      transition: width 0.3s ease;
    }
  }
</style>